import { Flow_0_0_2 } from '@flexus/core';

export const BUI_54: Flow_0_0_2 = {
	id: '54',
	name: 'maven_creation_failed',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'View possible fixes'
		},
		viewRoles: {
			0: '--'
		}
	},
	startNode: '',
	nodes: {}
};
